import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import {report_return_claim} from "../../../components/Report.js";
export default class ReturnGoods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_detail: false,
      tab: "create",

      filter_search: "",
      filter_product_id: "",
      filter_warehouse_id: "",
      filter_company_id: "",
      filter_start_date: "",
      filter_end_date: "",
      filter_activity_type: "",
      filter_status: "",

      data: [],
      count: 0,
      data_receive: [],
      data_user: [],
      data_warehouse: [],
      data_company: [],
      data_product: [],
      data_category: [],

      // stock
      uid: "",
      document_no: "",
      type: "",
      name: "",
      date: format_date(new Date(), "yyyy-mm-dd", "en"),
      start_date: "",
      end_date: "",
      count_item: "",
      ref_number: "",
      activity_type: "",
      customer_id: "",
      supplier_id: "",
      warehouse_id: "",
      destination_warehouse_id: "",
      user_id: "",
      amount: "",
      discount: "",
      vat: "",
      amount_net: "",
      cause: "",
      status: "",
      remark: "",
      transaction_list: [],

      // สินค้า
      photo: "",
      product_warehouse_id: "",
      product_code: "",
      product_name: "",
      category_id: "",
      unit_name: "",
      sale_price: "",
      cost_price: "",
      product_description: "",

      is_vat: false,
      delivery_cost: "",

      detail: null,
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }

  Get = async (page) => {
    const {
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_company_id,
      filter_status,
      filter_activity_type,
    } = this.state;
    loading(true);
    let data,
      count,
      data_user,
      data_receive,
      data_product,
      data_warehouse,
      data_category,
      data_company;
    let [
      result,
      result_user,
      result_receive,
      result_product,
      result_warehouse,
      result_category,
      result_company,
    ] = await Promise.all([
      GET("admin/stock-activities/list", {
        page: page,
        data_search: filter_search,
        start_date: filter_start_date,
        end_date: filter_end_date,
        warehouse_id: filter_warehouse_id,
        supplier_id: filter_company_id,
        status_code: filter_status,
        activity_type: filter_activity_type,
        type: "คืนสินค้าให้ Sup",
      }),
      GET("admin/setting/users/list", { page: 0, data_search: "" }),
      GET("admin/stock-activities/list", {
        page: 0,
        data_search: "",
        status_code: "เสร็จสิ้น",
        type: "รับสินค้า",
      }),
      GET("admin/inventories/list", { page: 0, data_search: "" }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
      GET("admin/setting/categories/list", { page: 0, data_search: "" }),
      GET("admin/setting/companies/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    if (result_user?.status) {
      data_user = result_user.data.map((e) => ({
        value: e.uid,
        label: e.full_name,
      }));
    }
    if (result_product?.status) {
      data_product = result_product.data
        .filter((e) => e.products)
        .map((e) => ({
          value: e.products?.uid,
          label: `${e.products?.product_code} ${e.products?.product_name}`,
          id: e.products?.id,
          warehouse_id: e.products?.warehouse?.uid || "",
          unit_name: e.products?.unit_name,
          is_serial_number: e.products?.is_serial_number,
          product_code: e.products?.product_code,
          product_name: e.products?.product_name,
          category_id: e.products?.category?.uid || "",
          balance: e.balance,
        }));
    }
    if (result_receive?.status) {
      data_receive = result_receive.data.map((e) => ({
        value: e.document_no,
        label: e.document_no,
        uid: e.uid,
      }));
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }
    if (result_category?.status) {
      data_category = result_category.data.map((e) => ({
        value: e.uid,
        label: `${e.category_code} ${e.name}`,
        id: e.id,
        warehouse_id: e.warehouse.uid,
      }));
    }
    if (result_company?.status) {
      data_company = result_company.data.map((e) => ({
        value: e.uid,
        label: e.company_name,
      }));
    }
    this.setState({
      data,
      count,
      data_user,
      data_receive,
      data_product,
      data_warehouse,
      data_category,
      data_company,
    });
    loading(false);
  };
  GetByID = async (uid) => {
    loading(true);
    let result = await GET("admin/stock-activities/list", { uid });
    this.setState({ detail: result.data, modal_detail: true });
    loading(false);
  };
  GetRef = async (uid) => {
    loading(true);
    const { data_product } = this.state;
    let result = await GET("admin/stock-activities/list", { uid });
    this.setState({
      transaction_list: result.data?.transaction_list?.map((e) => ({
        ...e,
        product_id:
          data_product.filter(
                                  (e) =>
                                    result.data?.warehouse?.uid &&
                                    e.warehouse_id === result.data?.warehouse?.uid
                                ).find((p) => p.product_code === e.product_code)?.value ||
          "",
        category_id:
          data_product.filter(
                                  (e) =>
                                    result.data?.warehouse?.uid &&
                                    e.warehouse_id === result.data?.warehouse?.uid
                                ).find((p) => p.product_code === e.product_code)
            ?.category_id || "",
        serial_number: e.serial_number?.join(",") || "",
      })),
      warehouse_id: result.data?.warehouse?.uid || "",
      supplier_id: result.data?.supplier.uid || "",
    });
    loading(false);
  };
  CreateUpdate = async (_status) => {
    const {
      data_product,
      id,
      uid,
      data,
      document_no,
      type,
      name,
      date,
      start_date,
      end_date,
      count_item,
      ref_number,
      activity_type,
      customer_id,
      supplier_id,
      warehouse_id,
      destination_warehouse_id,
      user_id,
      amount,
      discount,
      vat,
      amount_net,
      cause,
      status,
      remark,
      transaction_list,
      is_vat,
      delivery_cost,
    } = this.state;
    if (!date?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกวันที่คืนสินค้า");
      return;
    } else if (!supplier_id?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกบริษัทจำหน่าย");
      return;
    } else if (!activity_type?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทการคืน");
      return;
    } else if (!warehouse_id?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกคลังสินค้า (ที่คืนออก)");
      return;
    } else if (!user_id?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกผู้ดำเนินการ");
      return;
    }
    loading(true);

    let _amount = 0;

    transaction_list.forEach((item) => {
      const qty = Number(item.qty ?? 0);
      const unitPrice = Number(item.unit_price ?? 0);
      const itemDiscount = Number(item.discount ?? 0);
      _amount += qty * (unitPrice - itemDiscount);
      item.serial_number = item.serial_number.toString().split(",");
    });

    for (let item of transaction_list) {
      if (
        data_product.find((e) => e.value === item.product_id)
          ?.is_serial_number &&
        !item.serial_number
      ) {
        loading(false);
        alert("", "warning", "แจ้งเตือน", "กรุณากรอก serial number ให้ครบ");
        return;
      }
    }

    let body = {
      type: "คืนสินค้าให้ Sup",
      name,
      date,
      start_date,
      end_date,
      count_item: transaction_list.length,
      ref_number,
      activity_type,
      customer_id,
      supplier_id,
      warehouse_id,
      destination_warehouse_id,
      user_id,
      amount: Number(_amount),
      discount: 0,
      vat: 0,
      delivery_cost: 0,
      amount_net: Number(_amount),
      cause,
      status: _status || "เสร็จสิ้น",
      remark,
      transaction_list,
    };

    let result = !uid
      ? await POST("admin/stock-activities/create", body)
      : await PUT("admin/stock-activities/update/" + uid, body);
    if (result?.status) {
      alert("#", "success");
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };
  Approve = async (uid) => {
    if (
      await alert(
        "",
        "info",
        "ยืนยัน",
        "ยืนยันการรับสินค้าแล้ว ?",
        "ยืนยัน",
        "ยกเลิก"
      )
    ) {
      loading(true);

      let body = {
        status: "ตรวจรับสินค้า",
      };

      let result = await PUT("admin/stock-activities/update/" + uid, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
        );
      }
      loading(false);
    }
  };
  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "ยกเลิก",
        "ยืนยันรายการนี้หรือไม่ ?",
        "ยืนยัน",
        "ยกเลิก"
      )
    ) {
      loading(true);

      let body = {
        status: "ยกเลิก",
      };

      let result = await PUT("admin/stock-activities/update/" + id, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
        );
      }
      loading(false);
    }
  };

  render() {
    const {
      modal_detail,
      tab,

      filter_search,
      filter_product_id,
      filter_warehouse_id,
      filter_company_id,
      filter_start_date,
      filter_end_date,
      filter_activity_type,
      filter_status,

      data,
      count,
      data_user,
      data_receive,
      data_warehouse,
      data_company,
      data_product,
      data_category,

      // stock
      uid,
      document_no,
      type,
      name,
      date,
      start_date,
      end_date,
      count_item,
      ref_number,
      activity_type,
      customer_id,
      supplier_id,
      warehouse_id,
      destination_warehouse_id,
      user_id,
      amount,
      discount,
      vat,
      amount_net,
      cause,
      status,
      remark,
      transaction_list,

      // สินค้า
      photo,
      product_warehouse_id,
      product_code,
      product_name,
      category_id,
      unit_name,
      sale_price,
      cost_price,
      product_description,

      is_vat,
      delivery_cost,
      detail,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between flex-wrap mb-3">
              <h4 className="fw-bold mb-3 me-3">คืนสินค้าให้บริษัทจำหน่าย</h4>
              <div className="border-1 border-secondary rounded-4 p-1 d-flex bg-light">
                <button
                  className={`btn ${
                    tab === "create" ? "btn-dark" : "btn-light"
                  } px-3`}
                  onClick={async () => {
                    this.setState({
                      tab: "create",
                      date: format_date(new Date(), "yyyy-mm-dd", "en"),
                    });
                  }}
                >
                  สร้างรายการ
                </button>
                <div style={{ width: 4 }}></div>
                <button
                  className={`btn ${
                    tab === "history" ? "btn-dark" : "btn-light"
                  } px-3`}
                  onClick={async () => {
                    this.setState({
                      tab: "history",
                      id: "",
                      uid: "",
                      document_no: "",
                      type: "",
                      name: "",
                      date: "",
                      start_date: "",
                      end_date: "",
                      count_item: "",
                      ref_number: "",
                      activity_type: "",
                      customer_id: "",
                      supplier_id: "",
                      warehouse_id: "",
                      destination_warehouse_id: "",
                      user_id: "",
                      amount: "",
                      discount: "",
                      vat: "",
                      amount_net: "",
                      cause: "",
                      status: "",
                      remark: "",
                      transaction_list: [],
                    });
                  }}
                >
                  ประวัติรายการ
                </button>
              </div>
            </div>
            {tab === "create" && (
              <div>
                <div className="row mb-3">
                  <div className="col-12 col-sm-6 col-md-6 col-xl-4 mb-2">
                    <div className="mb-1">เลขที่เอกสารคืนสินค้า{required}</div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="เลขที่เอกสารคืนสินค้า..."
                      onChange={(e) => {
                        this.setState({ document_no: e.target.value });
                      }}
                      value={document_no}
                      disabled
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-4 mb-2">
                    <div className="mb-1">วันที่คืนสินค้า{required}</div>
                    <input
                      type="date"
                      className="form-control"
                      placeholder="วันที่คืนสินค้า..."
                      onChange={(e) => {
                        this.setState({ date: e.target.value });
                      }}
                      value={date}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-4 mb-2">
                    <div className="mb-1">บริษัทจำหน่าย{required}</div>
                    <Select
                      type="text"
                      className="form-control"
                      placeholder="บริษัทจำหน่าย..."
                      options={data_company}
                      onChange={(e) => {
                        this.setState({ supplier_id: e });
                      }}
                      value={supplier_id}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-4 mb-2">
                    <div className="mb-1">เลขที่อ้างอิงใบรับ (GR)</div>
                    <Select
                      type="text"
                      className="form-control"
                      placeholder="ระบุเลขที่อ้างอิงใบรับ (GR)..."
                      options={data_receive}
                      onChange={(e, i) => {
                        this.setState({ ref_number: e });
                        if (e) {
                          this.GetRef(i.uid);
                        }
                      }}
                      value={ref_number}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-4 mb-2">
                    <div className="mb-1">ประเภทการคืน{required}</div>
                    <select
                      className="form-control"
                      onChange={(e) => {
                        this.setState({ activity_type: e.target.value });
                      }}
                      value={activity_type}
                      disabled={uid}
                    >
                      <option value="">ประเภทการคืน</option>
                      <option value="คืนสินค้า">คืนสินค้า</option>
                      <option value="เคลมสินค้า">เคลมสินค้า</option>
                    </select>
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-4 mb-2">
                    <div className="mb-1">คลังสินค้า (ที่คืนออก){required}</div>
                    <Select
                      className="form-control"
                      placeholder="คลังสินค้า (ที่คืนออก)..."
                      options={data_warehouse}
                      onChange={(e) => {
                        this.setState({ warehouse_id: e });
                      }}
                      value={warehouse_id}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-4 mb-2">
                    <div className="mb-1">ผู้ดำเนินการ{required}</div>
                    <Select
                      className="form-control"
                      placeholder="ผู้ดำเนินการ..."
                      options={data_user}
                      onChange={(e) => {
                        this.setState({ user_id: e });
                      }}
                      value={user_id}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-4 mb-2">
                    <div className="mb-1">หมายเหตุ</div>
                    <textarea
                      rows={8}
                      type="text"
                      className="form-control"
                      placeholder="หมายเหตุ..."
                      onChange={(e) => {
                        this.setState({ remark: e.target.value });
                      }}
                      value={remark}
                    />
                  </div>
                </div>
                <hr />
                <div>
                  <div className="d-flex flex-wrap">
                    <Select
                      type="text"
                      className="form-control wpx-200 me-2 mb-2"
                      placeholder="ค้นหาสินค้า..."
                      options={data_product.filter(
                        (e) => warehouse_id && e.warehouse_id === warehouse_id
                      )}
                      onChange={(e) => {
                        this.setState({ filter_product_id: e.target.value });
                      }}
                      value={filter_product_id}
                    />
                    <div className="d-flex">
                      <button
                        className="btn btn-dark px-3 me-2 mb-2"
                        onClick={() => {
                          this.setState(
                            {
                              transaction_list: [
                                ...this.state.transaction_list,
                                {
                                  uid: "",
                                  type: "",
                                  product_id: "",
                                  product_name: "",
                                  product_code: "",
                                  product_type: "",
                                  serial_number: "",
                                  warehouse_id: "",
                                  warehouse_name: "",
                                  category_id: "",
                                  category_name: "",
                                  qty: 1,
                                  unit_name: "",
                                  cause: "",
                                  discount: "",
                                  sale_price: "",
                                  cost_price: "",
                                  unit_price: "",
                                  amount: "",
                                },
                              ],
                            },
                            () => {
                              try {
                                const index =
                                  this.state.transaction_list.length - 1;
                                document
                                  .getElementById("price-" + index)
                                  ?.focus();
                              } catch (e) {
                                console.error(
                                  "Error focusing on product input:",
                                  e
                                );
                              }
                            }
                          );
                        }}
                      >
                        เพิ่มรายการ
                      </button>
                    </div>
                  </div>
                  <div>
                    <table className="table rounded-3 table-hover">
                      <thead>
                        <tr>
                          <td className="text-nowrap">ลำดับ</td>
                          <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                          <td className="text-nowrap">Serial No.</td>
                          <td className="text-nowrap text-center">
                            สต็อกคงเหลือ
                          </td>
                          <td className="text-nowrap text-center">
                            จำนวนคืน/เคลม
                          </td>
                          <td className="text-nowrap">ราคาต้นทุน/หน่วย</td>
                          <td className="text-nowrap text-end">ราคารวม</td>
                          <td></td>
                        </tr>
                      </thead>
                      <tbody>
                        {transaction_list?.map((item, index) => (
                          <tr>
                            <td className="text-nowrap">{index + 1}</td>
                            <td className="text-nowrap">
                              <Select
                                className="form-control"
                                placeholder="ค้นหาสินค้า..."
                                options={data_product.filter(
                                  (e) =>
                                    warehouse_id &&
                                    e.warehouse_id === warehouse_id
                                )}
                                onChange={(e, i) => {
                                  transaction_list[index].product_id = e;
                                  transaction_list[index].product_code =
                                    i.product_code;
                                  transaction_list[index].product_name =
                                    i.product_name;
                                  transaction_list[index].unit_name =
                                    i.unit_name;
                                  transaction_list[index].category_id =
                                    i.category_id;
                                  this.setState({ transaction_list });
                                }}
                                value={item.product_id}
                              />
                            </td>
                            <td className="text-nowrap">
                              {data_product.find(
                                (e) => e.value === item.product_id
                              )?.is_serial_number && (
                                <input
                                  type="text"
                                  className="form-control mx-1"
                                  onChange={(e) => {
                                    transaction_list[index].serial_number =
                                      e.target.value;
                                    this.setState({ transaction_list });
                                  }}
                                  value={item.serial_number}
                                />
                              )}
                            </td>
                            <td className="text-nowrap text-center">
                              {data_product?.find(
                                (e) => e.value === item.product_id
                              )?.balance || 0}
                            </td>
                            <td className="text-nowrap">
                              <div className="d-flex align-items-center">
                                <button
                                  className="btn btn-primary wpx-30"
                                  onClick={async () => {
                                    if (item.qty <= 1) {
                                      if (
                                        await alert(
                                          "",
                                          "info",
                                          "ยืนยัน",
                                          "ยืนยันการลบข้อมูลนี้หรือไม่",
                                          "ลบข้อมูล",
                                          "ยกเลิก"
                                        )
                                      ) {
                                        this.setState({
                                          transaction_list:
                                            transaction_list.filter(
                                              (_, i) => i !== index
                                            ),
                                        });
                                      }
                                    } else {
                                      transaction_list[index].qty = Math.max(
                                        0,
                                        item.qty - 1
                                      );
                                      this.setState({ transaction_list });
                                    }
                                  }}
                                >
                                  -
                                </button>
                                <input
                                  type="text"
                                  className="form-control wpx-60 mx-1 text-center"
                                  onChange={(e) => {
                                    if (!float(e.target.value)) return;
                                    transaction_list[index].qty = Number(
                                      e.target.value
                                    );
                                    this.setState({ transaction_list });
                                  }}
                                  value={item.qty}
                                />
                                <button
                                  className="btn btn-primary wpx-30"
                                  onClick={() => {
                                    transaction_list[index].qty = Math.max(
                                      0,
                                      item.qty + 1
                                    );
                                    this.setState({ transaction_list });
                                  }}
                                >
                                  +
                                </button>
                              </div>
                            </td>
                            <td className="text-nowrap">
                              <input
                                type="text"
                                className="form-control wpx-100 mx-1 text-end"
                                onChange={(e) => {
                                  if (!float(e.target.value)) return;
                                  transaction_list[index].unit_price = Number(
                                    e.target.value
                                  );
                                  this.setState({ transaction_list });
                                }}
                                onKeyUp={(e) => {
                                  if (e.key === "Enter") {
                                    if (index === transaction_list.length - 1) {
                                      this.setState(
                                        {
                                          transaction_list: [
                                            ...transaction_list,
                                            {
                                              uid: "",
                                              type: "",
                                              product_id: "",
                                              product_name: "",
                                              product_code: "",
                                              product_type: "",
                                              serial_number: "",
                                              warehouse_id: "",
                                              warehouse_name: "",
                                              category_id: "",
                                              category_name: "",
                                              qty: 1,
                                              unit_name: "",
                                              cause: "",
                                              discount: "",
                                              sale_price: "",
                                              cost_price: "",
                                              unit_price: "",
                                              amount: "",
                                            },
                                          ],
                                        },

                                        () => {
                                          try {
                                            const index =
                                              this.state.transaction_list
                                                .length - 1;
                                            document
                                              .getElementById("price-" + index)
                                              ?.focus();
                                          } catch (e) {
                                            console.error(
                                              "Error focusing on product input:",
                                              e
                                            );
                                          }
                                        }
                                      );
                                    } else {
                                      try {
                                        document
                                          .getElementById(
                                            "price-" + (index + 1)
                                          )
                                          .focus();
                                      } catch (e) {
                                        console.error(
                                          "Error focusing on product input:",
                                          e
                                        );
                                      }
                                    }
                                  }
                                }}
                                value={item.unit_price}
                                id={`price-${index}`}
                              />
                            </td>

                            <td className="text-nowrap text-end">
                              {toFixed(
                                Number(item.qty) * Number(item.unit_price)
                              ) || "0.00"}
                            </td>
                            <td className="text-center align-middle wpx-100">
                              <div className="d-flex">
                                <BtnIcon
                                  className="receive-goods.delete"
                                  type="delete"
                                  onClick={async () => {
                                    if (
                                      await alert(
                                        "",
                                        "info",
                                        "ยืนยัน",
                                        "ยืนยันการลบข้อมูลนี้หรือไม่",
                                        "ลบข้อมูล",
                                        "ยกเลิก"
                                      )
                                    ) {
                                      this.setState({
                                        transaction_list:
                                          transaction_list.filter(
                                            (_, i) => i !== index
                                          ),
                                      });
                                    }
                                  }}
                                />
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>

                      <tfoot>
                        <tr>
                          <td colSpan={4}>รวมทั้งสิ้น</td>
                          <td className="text-center">
                            {total(transaction_list, "qty")}
                          </td>
                          <td></td>
                          <td></td>
                          <td className="text-end">
                            <h4 className="fw-bold">
                              {(() => {
                                let total = 0;
                                transaction_list.forEach((item) => {
                                  total +=
                                    Number(item.qty) * Number(item.unit_price);
                                });
                                if (isNaN(total)) total = 0;
                                return toFixed(total || 0);
                              })()}
                            </h4>
                          </td>
                          <td></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <div className="pt-0 border-0 d-flex justify-content-end">
                  <div className="d-flex">
                    <button
                      className="btn btn-dark px-5 me-1"
                      onClick={() => {
                        this.CreateUpdate(
                          activity_type === "เคลมสินค้า"
                            ? "รอรับกลับ"
                            : "เสร็จสิ้น"
                        );
                      }}
                    >
                      บันทึกการคืน/เคลมสินค้า
                    </button>
                  </div>
                </div>
              </div>
            )}
            {tab === "history" && (
              <div>
                <div className="d-flex align-items-center flex-wrap">
                  <input
                    type="text"
                    className="form-control wpx-200 me-2 mb-2"
                    placeholder="ค้นหาเลขที่เอกสาร..."
                    onChange={(e) => {
                      this.setState({ filter_search: e.target.value });
                    }}
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        this.Get(1);
                      }
                    }}
                    value={filter_search}
                  />
                  <div className="wpx-200 me-2 mb-2">
                    <Select
                      className="form-control"
                      placeholder="คลังสินค้า..."
                      options={data_warehouse}
                      onChange={(e) => {
                        this.setState({ filter_warehouse_id: e });
                      }}
                      value={filter_warehouse_id}
                    />
                  </div>
                  <div className="wpx-200 me-2 mb-2">
                    <Select
                      className="form-control"
                      placeholder="บริษัทจำหน่าย..."
                      options={data_company}
                      onChange={(e) => {
                        this.setState({ filter_company_id: e });
                      }}
                      value={filter_company_id}
                    />
                  </div>
                  <input
                    type="date"
                    className="form-control wpx-200 me-2 mb-2"
                    onChange={(e) => {
                      this.setState({ filter_start_date: e.target.value });
                    }}
                    value={filter_start_date}
                  />
                  <span className="px-2 me-2 mb-2">ถึง</span>
                  <input
                    type="date"
                    className="form-control wpx-200 me-2 mb-2"
                    onChange={(e) => {
                      this.setState({ filter_end_date: e.target.value });
                    }}
                    value={filter_end_date}
                  />
                  <select
                    className="form-control wpx-200 me-2 mb-2"
                    onChange={(e) => {
                      this.setState({ filter_activity_type: e.target.value });
                    }}
                    value={filter_activity_type}
                  >
                    <option value="">ประเภทการคืน</option>
                    <option value="คืนสินค้า">คืนสินค้า</option>
                    <option value="เคลมสินค้า">เคลมสินค้า</option>
                  </select>
                  <select
                    className="form-control wpx-200 me-2 mb-2"
                    onChange={(e) => {
                      this.setState({ filter_status: e.target.value });
                    }}
                    value={filter_status}
                  >
                    <option value="">สถานะ</option>
                    {(!filter_activity_type ||
                      filter_activity_type === "คืนสินค้า") && (
                      <option value="คืนสินค้า">คืนสินค้า</option>
                    )}

                    {(!filter_activity_type ||
                      filter_activity_type === "เคลมสินค้า") && (
                      <option value="รอรับกลับ">รอรับกลับ</option>
                    )}
                    {(!filter_activity_type ||
                      filter_activity_type === "เคลมสินค้า") && (
                      <option value="ตรวจรับสินค้า">ตรวจรับสินค้า</option>
                    )}
                    <option value="ยกเลิก">ยกเลิก</option>
                  </select>
                  <div className="d-flex">
                    <button
                      className="btn btn-dark px-3 me-2 mb-2"
                      onClick={() => {
                        this.Get(1);
                      }}
                    >
                      ค้นหา
                    </button>
                    <button
                      className="btn btn-outline-dark px-3 me-2 mb-2"
                      onClick={() => {
                        this.setState({
                          filter_search: "",
                          filter_receive_date: "",
                          filter_warehouse_id: "",
                          filter_company_id: "",
                          filter_category_id: "",
                          filter_status: "",
                          filter_start_date: "",
                          filter_end_date: "",
                          filter_activity_type: "",
                        });
                        setTimeout(() => {
                          this.Get(1);
                        }, 100);
                      }}
                    >
                      ล้างค่า
                    </button>
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="table rounded-3 overflow-hidden table-hover">
                    <thead>
                      <tr>
                        <td className="text-nowrap">เลขที่เอกสาร</td>
                        <td className="text-nowrap">วันที่เอกสาร</td>
                        <td className="text-nowrap">คลังสินค้า</td>
                        <td className="text-nowrap">บริษัทจำหน่าย</td>
                        <td className="text-nowrap">ประเภท</td>
                        <td className="text-nowrap">สถานะ</td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((item, index) => (
                        <tr>
                          <td className="text-nowrap">
                            {item.document_no || "-"}
                          </td>
                          <td className="text-nowrap">
                            {item.created_at
                              ? format_date(item.created_at)
                              : "-"}
                          </td>
                          <td className="text-nowrap">
                            {item.warehouse?.name || "-"}
                          </td>
                          <td className="text-nowrap">
                            {item.supplier?.company_name || "-"}
                          </td>
                          <td className="text-nowrap">
                            {item.activity_type || "-"}
                          </td>
                          <td className="text-nowrap">{item.status || "-"}</td>
                          <td className="text-center align-middle wpx-150">
                            <div className="d-flex">
                              <BtnIcon
                                type="view"
                                onClick={async () => {
                                  await this.GetByID(item.uid);
                                }}
                              />
                              {item.status === "รอรับกลับ" && (
                                <BtnIcon
                                  className="return-goods.delete"
                                  type="approve"
                                  onClick={async () => {
                                    this.Approve(item.uid);
                                  }}
                                />
                              )}
                              {["รอรับกลับ", "เสร็จสิ้น"].includes(
                                item.status
                              ) && (
                                <BtnIcon
                                  className="return-goods.delete"
                                  type="delete"
                                  onClick={() => {
                                    this.Delete(item.uid);
                                  }}
                                />
                              )}
                              <BtnIcon
                                type="print"
                                onClick={() => {
                                 report_return_claim(item.uid);
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
                  <Pagination
                    className="mb-3"
                    count={Math.ceil(count / 10) || 1}
                    showFirstButton
                    showLastButton
                    onChange={(_, page) => this.Get(page)}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* VIEW */}
        <Modal
          show={this.state.modal_detail}
          onHide={() => this.setState({ modal_detail: false })}
          fullscreen={true}
        >
          <Modal.Header closeButton>
            <h4 className="mb-0">รายละเอียด</h4>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">สถานะ</label>
              <label>{detail?.status}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">เลขที่เอกสารคืนสินค้า</label>
              <label>{detail?.document_no || ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">วันที่คืนสินค้า</label>
              <label>{detail?.date ? format_date(detail?.date) : ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">บริษัทจำหน่าย</label>
              <label>{detail?.supplier?.company_name || ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">เลขที่อ้างอิงใบรับ (GR)</label>
              <label>{detail?.ref_number || ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">ประเภทการคืน</label>
              <label>{detail?.activity_type || ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">คลังสินค้า (ที่คืนออก)</label>
              <label>{detail?.warehouse?.name || ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">ผู้ดำเนินการ</label>
              <label>{detail?.user?.full_name || ""}</label>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">ลำดับ</td>
                    <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                    <td className="text-nowrap">Serial No.</td>
                    <td className="text-nowrap text-center">จำนวน</td>
                    <td className="text-nowrap text-center">ราคา/หน่วย</td>
                    <td className="text-nowrap text-end">มูลค่ารวม</td>
                  </tr>
                </thead>
                <tbody>
                  {detail?.transaction_list?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{index + 1}</td>
                      <td className="text-nowrap">
                        {item.product_code} {item.product_name}
                      </td>
                      <td className="text-nowrap">
                        {item.serial_number?.join(", ") || ""}
                      </td>
                      <td className="text-nowrap">{item.qty}</td>
                      <td className="text-nowrap">{item.unit_price}</td>
                      <td className="text-nowrap text-end">
                        {toFixed(Number(item.qty) * Number(item.unit_price))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between">
              <div>
                <div className="d-flex mb-2 flex-wrap">
                  <label className="wpx-150">หมายเหตุ</label>
                  <label>{detail?.remark || ""}</label>
                </div>
              </div>
              <div>
                <div className="ms-auto d-flex mb-2 flex-wrap">
                  <label className="wpx-150">รวมเป็นเงิน</label>
                  <label className="wpx-100 text-end px-3">
                    {toFixed(detail?.amount)}
                  </label>
                  <label>บาท</label>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
